"use client";

import { useEffect } from "react";

export function DevtoolsInjector() {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      const script = document.createElement("script");
      script.src = "http://localhost:8097";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return null;
}
